import styled from "styled-components";

import { numericFontStyles } from "_/style";

export const LabeledSlider = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.375rem;

  width: 100%;
`;

export const ControlLabel = styled.span`
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  width: 100%;
  font-size: 0.875rem;
  color: ${(p) => p.theme.text.muted};
  font-weight: 600;
`;

export const SliderValueLabel = styled.span`
  font-weight: 400;
  color: ${(p) => p.theme.text.muted};
  white-space: nowrap;
  margin-left: 0.5rem;

  /* Prevent labels from jumping around while dragging slider thumb. */
  ${numericFontStyles}
`;
